'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  0%,\n  80%,\n  100% {\n    box-shadow: 0 0;\n    height: 4em;\n  }\n  40% {\n    box-shadow: 0 -2em;\n    height: 5em;\n  }\n'], ['\n  0%,\n  80%,\n  100% {\n    box-shadow: 0 0;\n    height: 4em;\n  }\n  40% {\n    box-shadow: 0 -2em;\n    height: 5em;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation: ', ';\n  animation-delay: ', ';\n  background: ', ';\n  color: ', ';\n  font-size: ', ';\n  height: 4em;\n  margin: 88px auto;\n  position: relative;\n  text-indent: -9999em;\n  transform: translateZ(0);\n  width: 1em;\n\n  &:before {\n    animation: ', ';\n    animation-delay: ', ';\n    background: ', ';\n    content: \'\';\n    height: 4em;\n    left: -1.5em;\n    position: absolute;\n    top: 0;\n    width: 1em;\n  }\n\n  &:after {\n    animation: ', ';\n    animation-delay: ', ';\n    background: ', ';\n    content: \'\';\n    height: 4em;\n    left: 1.5em;\n    position: absolute;\n    top: 0;\n    width: 1em;\n  }\n'], ['\n  animation: ', ';\n  animation-delay: ', ';\n  background: ', ';\n  color: ', ';\n  font-size: ', ';\n  height: 4em;\n  margin: 88px auto;\n  position: relative;\n  text-indent: -9999em;\n  transform: translateZ(0);\n  width: 1em;\n\n  &:before {\n    animation: ', ';\n    animation-delay: ', ';\n    background: ', ';\n    content: \'\';\n    height: 4em;\n    left: -1.5em;\n    position: absolute;\n    top: 0;\n    width: 1em;\n  }\n\n  &:after {\n    animation: ', ';\n    animation-delay: ', ';\n    background: ', ';\n    content: \'\';\n    height: 4em;\n    left: 1.5em;\n    position: absolute;\n    top: 0;\n    width: 1em;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var loading = (0, _styledComponents.keyframes)(_templateObject);

var Bar = _styledComponents2.default.div(_templateObject2, function (props) {
  return loading + ' ' + props.duration + 's infinite ease-in-out';
}, function (props) {
  return props.duration * -0.16 + 's';
}, function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.size + 'px';
}, function (props) {
  return loading + ' ' + props.duration + 's infinite ease-in-out;';
}, function (props) {
  return props.duration * -0.32 + 's';
}, function (props) {
  return props.color;
}, function (props) {
  return loading + ' ' + props.duration + 's infinite ease-in-out';
}, function (props) {
  return props.duration * 0.08 + 's';
}, function (props) {
  return props.color;
});

exports.default = Bar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-css-loaders2/dist/bar/Bar.js
// module id = 549
// module chunks = 0